import { ExtractionSource } from "../../groopit-js/client";
import * as React from "react";
import { useContext } from "react";
import { FilterContext } from "../FeedFilter/State/FilterContext";
import Highlighter from "react-highlight-words";
import { getFilterKeywords } from "../FeedFilter/GroopitFilterDTO";

interface ExtractionSourceView {
  extractionSource?: ExtractionSource;
}

export const ExtractionSourceView = (
  props: ExtractionSourceView,
): JSX.Element => {
  const filterContext = useContext(FilterContext);

  if (!(props.extractionSource && props.extractionSource.includeSource)) {
    return <></>;
  }

  return (
    <>
      <div className="my-4">
        <div className="text-display-caption text-app-orange">Source</div>
        <div className="text-display-caption">
          {getFilterKeywords(filterContext?.filter).length ? (
            <Highlighter
              searchWords={getFilterKeywords(filterContext?.filter)}
              textToHighlight={props.extractionSource.value ?? ""}
              highlightClassName="search-highlight"
            ></Highlighter>
          ) : (
            <>{props.extractionSource.value}</>
          )}
        </div>
      </div>
    </>
  );
};
